import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import NavigationSettings from './navigation-settings';

export default function Profile() {
    const { t } = useTranslation();

    return (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 800, width: '100%' }}>
                {/* Profile Information Card - Hidden for now */}
                {/*
                <Card sx={{ mb: 3 }}>
                    <CardContent sx={{ textAlign: 'center', py: 4 }}>
                        {userProfile.first_name && userProfile.last_name && (
                            <>
                                <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: 'primary.main', fontSize: 32 }}>
                                    {initials}
                                </Avatar>

                                <Typography variant="h5" gutterBottom>
                                    {fullName}
                                </Typography>
                            </>
                        )}

                        <Box sx={{ mt: 3, textAlign: 'left' }}>
                            {userProfile.first_name && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                                    <Typography color="text.secondary">{t('PROFILE.FIRST_NAME')}</Typography>
                                    <Typography fontWeight={500}>{userProfile.first_name}</Typography>
                                </Box>
                            )}
                            {userProfile.last_name && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                                    <Typography color="text.secondary">{t('PROFILE.LAST_NAME')}</Typography>
                                    <Typography fontWeight={500}>{userProfile.last_name}</Typography>
                                </Box>
                            )}

                            {userProfile.context && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                                    <Typography color="text.secondary">{t('PROFILE.CONTEXT')}</Typography>
                                    <Typography fontWeight={500} sx={{ ml: 2, textAlign: 'right' }}>{userProfile.context}</Typography>
                                </Box>
                            )}

                            {userProfile.plan && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Typography color="text.secondary">{t('PROFILE.PLAN')}</Typography>
                                    <Box sx={{ textAlign: 'right' }}>
                                        {hasPlan ? (
                                            <Chip
                                                label={t(planLabels[userProfile.plan])}
                                                color="primary"
                                                size="small"
                                            />
                                        ) : (
                                            <Chip
                                                label={t('PROFILE.NO_PLAN')}
                                                size="small"
                                                variant="outlined"
                                            />
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {hasTrial && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography color="text.secondary">{t('PROFILE.TRIAL_END')}</Typography>
                                    <Box sx={{ textAlign: 'right' }}>
                                        <Typography fontWeight={500}>{formattedDate}</Typography>
                                        <Chip
                                            label={trialExpired
                                                ? t('PROFILE.TRIAL_EXPIRED')
                                                : t('PROFILE.TRIAL_DAYS_LEFT', { count: daysLeft })}
                                            color={trialExpired ? 'error' : 'success'}
                                            size="small"
                                            variant="outlined"
                                            sx={{ mt: 0.5 }}
                                        />
                                    </Box>
                                </Box>
                            )}
                        </Box>

                        {userProfile.plan !== undefined && (
                            <Button
                                variant="contained"
                                startIcon={<ShoppingCartIcon />}
                                onClick={() => navigate('/main/applications/subscription')}
                                sx={{ mt: 4 }}
                            >
                                {hasPlan ? t('PROFILE.CHANGE_PLAN') : t('PROFILE.SUBSCRIBE')}
                            </Button>
                        )}
                    </CardContent>
                </Card>
                */}

                {/* Settings Card */}
                <Card>
                    <CardContent sx={{ py: 4, px: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            {t('PROFILE.SETTINGS_TITLE')}
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        <NavigationSettings />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
}
